export var STARTER_PLAN = "starter_plan";
export var GOLD_PLAN = "gold_annual";
export var GOLD_SEMESTER_PLAN = "gold_semester";

export var SILVER_PLAN_2019 = "silver_annual_2019";
export var SILVER_SEMESTER_PLAN_2019 = "silver_semester_2019";

export var RLD_ONLY_SEMESTER = "rld_semester";
export var RLD_ONLY_ANNUAL = "rld_annual";

// Old plans
export var SILVER_PLAN = "silver_annual";
export var SILVER_SEMESTER_PLAN = "silver_semester";

export var PAID_PLANS = [GOLD_PLAN, GOLD_SEMESTER_PLAN, SILVER_PLAN_2019, SILVER_SEMESTER_PLAN_2019];
export var PAID_ANNUAL_PLANS = [GOLD_PLAN, SILVER_PLAN_2019]

var PLAN_CONFIG = {
	[STARTER_PLAN]: {
		name: "Starter",
		increase_type: "silver"
	},
	[GOLD_PLAN]: {
		name: "Gold",
		per_student_list_price: 22500,
		increase_type: "gold"
	},
	[GOLD_SEMESTER_PLAN]: {
		name: "Gold (6 Months)",
		per_student_list_price: 13500,
		increase_type: "gold",
		semester: true
	},

	[SILVER_PLAN_2019]: {
		name: "Silver",
		fixed_price: 11500,
		per_student_list_price: 5000,
		increase_type: "silver"
	},
	[SILVER_SEMESTER_PLAN_2019]: {
		name: "Silver (6 Months)",
		fixed_price: 7000,
		per_student_list_price: 3000,
		increase_type: "silver",
		semester: true
	},

	[RLD_ONLY_ANNUAL]: {
		name: "RLD Only"
	},
	[RLD_ONLY_SEMESTER]: {
		name: "RLD Only (6 Months)",
		semester: true
	},

	// Old plans
	[SILVER_PLAN]: {
		name: "Silver (Legacy)",
		fixed_price: 12500,
		per_student_list_price: 2500,
		increase_type: "silver"
	},
	[SILVER_SEMESTER_PLAN]: {
		name: "Silver (6 Months, Legacy)",
		fixed_price: 7500,
		per_student_list_price: 1500,
		increase_type: "silver",
		semester: true
	},

}

PLAN_CONFIG[GOLD_PLAN].class_pricing_tiers = [
	{ price: 22500, min: 1,  max: 4 },
	{ price: 17500, min: 5,  max: 9 },
	{ price: 15000, min: 10, max: 19 },
	{ price: 11500, min: 20, max: 149 },
	{ price: 8500,  min: 150,  max: 9999 },
]

PLAN_CONFIG[GOLD_SEMESTER_PLAN].class_pricing_tiers = 
	PLAN_CONFIG[GOLD_PLAN].class_pricing_tiers.map((tier) => {
		var price = tier.price * 0.6
		// handle ugly prices (2022 price changes)
		if (price == 6900) { price = 7000 }
		if (price == 5100) { price = 5000 }
		return _.extend({}, tier, { price })
})

var RLD_ANNUAL_CLASS_PRICING_TIERS = [
	{ price: 6000, min: 1,  max: 15 },
	{ price: 5000, min: 16, max: 50 },
	{ price: 3500, min: 51, max: 9999 }
]
var RLD_SEMESTER_CLASS_PRICING_TIERS = RLD_ANNUAL_CLASS_PRICING_TIERS.map((tier) => {
	return _.extend({}, tier, { price: (tier.price * 0.6) })
})

export function name(plan) {
	if (PLAN_CONFIG[plan]) {
		return PLAN_CONFIG[plan].name;
	}
}

export function nameToKey(name) {
	var matchKey;
	_.find(PLAN_CONFIG, (config, plan) => {
		if (config.name == name) {
			matchKey = plan;
			return true;
		}
	});
	return matchKey;
}
// display name from plan_type attribute saved in db
export function displayName(plan) {
	switch (plan) {
		case 'gold_annual':
			return 'Gold'
			break;
		case 'gold_semester':
			return 'Gold(6 Months)'
			break;
		case 'silver_annual_2019':
			return 'Silver';
			break;
		case 'silver_semester_2019':
			return 'Silver(6 Months)';
			break;
		case 'gold_annual-trial':
			return 'Trial: Gold';
			break;
		case 'silver_anunual-trial':
			return 'Trial: Silver';
			break;
	}
}

export function increaseType(plan) {
	if (PLAN_CONFIG[plan]) {
		return PLAN_CONFIG[plan].increase_type;
	}
}

export function pricingSummary(plan) {
	if (PLAN_CONFIG[plan]) {

		if (PLAN_CONFIG[plan].semester) {
			// Make sure period is clearly spelled out elsewhere
			var perText = "";
		} else {
			var perText = "/year";
		}
		var marginalCost = PLAN_CONFIG[plan].per_student_list_price;
		var fixedCost = PLAN_CONFIG[plan].fixed_price;

		if (fixedCost && marginalCost) {
			return $wr.centsToDollars(fixedCost + marginalCost, true)
				+ perText + ", +"
				+ $wr.centsToDollars(marginalCost, true)
				+ "/class" + perText;

		} else if (marginalCost) {
			return $wr.centsToDollars(marginalCost, true) + "/class" + perText;

		} else if (fixedCost) {
			return $wr.centsToDollars(fixedCost, true) + perText;
		}
	}
}

export function price(plan, studentListCount) {
	if (PLAN_CONFIG[plan]) {
		var marginalCost = PLAN_CONFIG[plan].per_student_list_price || 0;
		var fixedCost = PLAN_CONFIG[plan].fixed_price || 0;
		return fixedCost + (marginalCost * studentListCount);
	}
}

export function perClassPrice(plan) {
	if (PLAN_CONFIG[plan]) {
		return PLAN_CONFIG[plan].per_student_list_price || 0;
	}
}

export function fixedPrice(plan) {
	if (PLAN_CONFIG[plan]) {
		return PLAN_CONFIG[plan].fixed_price || 0;
	}
}

export function tieredPrice({ plan, studentListCount, teacherCount, withRLDs, discount }) {
	if (PLAN_CONFIG[plan]) {
		var lineItems = itemizedQuote({ plan, studentListCount, teacherCount, withRLDs, discount });
		return _.reduce(lineItems, (memo, item) => memo + item.total_price, 0);
	}
}

export function calculateTieredPrice({ plan, tiers, count, subject, singular, plural }) {
	var remaining = count;
	var lines = [];

	_.each(tiers, (tier) => {
		var range = 1 + tier.max - tier.min;

		var tierTotal, count, description;

		if (remaining >= range) {
			tierTotal = range * tier.price;
			remaining -= range;
			count = range;

		} else if (remaining > 0) {
			tierTotal = remaining * tier.price;
			count = remaining;
			remaining = 0;
		}

		if (count && count > 0) {
			if (count == 1) {
				description = $wr.getOrdinal(tier.min) + " " + singular;

			} else if (tier.min == 1) {
				description = "First " + $wr.pluralizeWithNumber(singular, count, plural);

			} else {
				description = $wr.getOrdinal(tier.min) + " to " + 
					$wr.getOrdinal(tier.min + count - 1) + " " + plural;
				
			}

			lines.push({
				plan, count, description, subject: subject, 
				unit_price: tier.price, total_price: tierTotal
			});					
		}
	});

	return lines;
}

export function itemizedQuote({ plan, studentListCount, teacherCount, withRLDs, discount, discountReason }) {
	var config = PLAN_CONFIG[plan];
	var lines = [];
	if (config) {
		if (config.fixed_price) {
			lines.push({
				plan, subject: TEACHERS_SUBJECT, count: teacherCount,
				unit_price: config.fixed_price, total_price: (config.fixed_price * teacherCount)
			})
		}
		if (config.class_pricing_tiers) {
			lines = lines.concat(calculateTieredPrice({
				plan: plan,
				tiers: config.class_pricing_tiers,
				count: studentListCount,
				subject: CLASSES_SUBJECT,
				singular: "class",
				plural: "classes"
			}))

		} else if (config.per_student_list_price) {
			lines.push({
				plan, subject: CLASSES_SUBJECT, count: studentListCount,
				unit_price: config.per_student_list_price,
				total_price: (config.per_student_list_price * studentListCount)
			})
		}
	}

	if (withRLDs) {
		var tiers = config.semester ? RLD_SEMESTER_CLASS_PRICING_TIERS : RLD_ANNUAL_CLASS_PRICING_TIERS;
		lines = lines.concat(calculateTieredPrice({
			plan: plan,
			tiers: tiers,
			count: studentListCount,
			subject: RLD_SUBJECT,
			singular: "class",
			plural: "classes"
		}))
	}

	if (discount) {
		lines.push({
			plan, subject: DISCOUNT_SUBJECT, count: 1,
			unit_price: -1 * discount, total_price: -1 * discount,
			description: discountReason
		})
	}

	return lines;
}

// Estimate subjects
var TEACHERS_SUBJECT = "teachers";
var CLASSES_SUBJECT = "classes";
var DISCOUNT_SUBJECT = "discount";
var RLD_SUBJECT = "rlds";

export var PRODUCTS = {
	WR_SOLO: "wrSolo",
	WR_SILVER: "wrSilver",
	WR_GOLD: "wrGold"
}


// WEBPACK FOOTER //
// ./modules/lib/account/AccountPlans.js